import { render, staticRenderFns } from "./ModifierList.vue?vue&type=template&id=debec0e8&"
import script from "./ModifierList.vue?vue&type=script&lang=js&"
export * from "./ModifierList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports